export default __webpack_public_path__ + "static/media/login.8c28b687.jpg";